// removed by extract-text-webpack-plugin
module.exports = {"spinnerWrap":"LoadPage-SimilarLoads-spinnerWrap","wrap":"LoadPage-SimilarLoads-wrap","item1":"LoadPage-SimilarLoads-item1","red":"LoadPage-SimilarLoads-red","loadWrap":"LoadPage-SimilarLoads-loadWrap","tit":"LoadPage-SimilarLoads-tit","marginStyle":"LoadPage-SimilarLoads-marginStyle","showAll":"LoadPage-SimilarLoads-showAll","icon":"LoadPage-SimilarLoads-icon","bgColor":"LoadPage-SimilarLoads-bgColor"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadPage/SimilarLoads/index.css
// module id = 1715
// module chunks = 0